import { Cancel, CheckCircle } from "@mui/icons-material";
import { Box, Link, Typography, useMediaQuery } from "@mui/material";

const QuoteColumns = () => {
    // Define the breakpoints
    const isMobile = useMediaQuery('(max-width:600px)');    
    return [
        {
            field: "quoteNumber",
            headerName: "Quote #",
            flex: 1.5,
            renderCell: ({ row: { _id, quoteNumber } }) => (
                <Link
                    className="hive-grid-link-cell"
                    // href={"#"}
                    href={`/base-unique-quote/${_id}`}
                    underline="none"
                    sx={{ color: 'rgb(70 128 255)', fontWeight: 500 }} // adjust color here rgb(70 128 255)
                >
                {quoteNumber}
                </Link>
            )
        },
        {
            field: "revision",
            headerName: "Revision",
            // flex: 1
        },
        // Conditionally show/hide columns
        ...(isMobile ? [] : [        
        // {
        //     field: "totalCost",
        //     headerName: "Cost",
        //     flex: 0,
        //     renderCell: ({ row: { lines = [] } }) => {

        //     const total = lines.filter(l => l.type !== "subtotal").reduce(
        //         (sum, line) => sum + (Number(line.extCost) || 0),
        //         0
        //     );

        //     return (
        //         <Box
        //         sx={{
        //             display: 'flex',
        //             alignItems: 'center',
        //             height: '100%',
        //         }}
        //         >
        //         <Typography sx={{ color: '#592e7dff', fontWeight: 500, fontSize: '0.875rem' }}>
        //             {new Intl.NumberFormat("en-US", {
        //             style: "currency",
        //             currency: "USD",
        //             }).format(total)}
        //         </Typography>
        //         </Box>
        //     );
        //     }            
        // },                  
        {
            field: "lines",
            headerName: "Price",
            flex: 0,
            renderCell: ({ row: { lines = [] } }) => {

            const total = lines.filter(l => l.type !== "subtotal" && l.type !== "runningsubtotal").reduce(
                (sum, line) => sum + (Number(line.extPrice) || 0),
                0
            );

            return (
                <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    height: '100%',
                }}
                >
                <Typography className="hive-grid-price-cell" sx={{ color: '#2e7d32', fontWeight: 500, fontSize: '0.875rem' }}>
                    {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    }).format(total)}
                </Typography>
                </Box>
            );
            },   
            valueGetter: (params) => params.filter(l => l.type !== "subtotal" && l.type !== "runningsubtotal").reduce((sum,line) => sum + (Number(line.extPrice) || 0), 0)       
        },   
        {
            field: "projectNumber",
            headerName: "Project #",
            // flex: 1
        },
        {
            field: "orderDate",
            headerName: "Order Date",
            type: "date",
            flex: 1,
            valueGetter: (value) => value ? new Date(value) : null,
            renderCell: ({ value }) => value instanceof Date && !Number.isNaN(value.getTime())
                ? value.toISOString().split("T")[0]
                : "",
        },
        {
            field: "shipTo",
            headerName: "Customer",
            flex: 1,
            renderCell: ({ row: { shipTo } }) => shipTo?.company || "",
            valueGetter: (params) => params?.company ? params.company : ""
        },

        {
            field: "salesManager",
            headerName: "Sales Manager",
            flex: 1,
            renderCell: ({ row: { salesManager } }) => salesManager ? `${salesManager.firstName} ${salesManager.lastName}` : 'Unassigned',
            valueGetter: (params) => `${params.firstName} ${params.lastName}`          
        },      
        {
            field: "updatedBy",
            headerName: "Last Updated By",
            flex: 1,
            renderCell: ({ row: { updatedBy } }) => updatedBy ? `${updatedBy.firstName} ${updatedBy.lastName}` : 'Unassigned',
            valueGetter: (params) => `${params.firstName} ${params.lastName}`          
        },                
        {
            field: "updatedAt",
            headerName: "Last Updated",
            flex: 1,
            renderCell: ({ row: { updatedAt } }) => {
                if (!updatedAt) return "";
                const date = typeof updatedAt === "string" ? new Date(updatedAt) : updatedAt;
                return date.toISOString().split("T")[0]; // 'YYYY-MM-DD'
            },              
        },
        {
            field: "tags",
            headerName: "Tagged",
            renderCell: ({ row: { tags } }) => {
                return (
                    <>
                        {tags ? tags.length ? <CheckCircle color="success" /> : <Cancel color="error"/> : <Cancel color="error"/>}
                    </>
                );
            },
            valueGetter: (params) => params?.length ? true : false
        }
        ])
    ]
}

export default QuoteColumns
